import config from 'config';
import * as types from '../actions/login-actions';

const initialState = {
	msisdn: null,
	activationStep: config.constants.activationSteps.unknownUser,
	msisdnInHeader: false
};

const loginReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.RESET_VALUES:
			return Object.assign({}, state, initialState);
			break;

		case types.ACTIVATION_STEP:
			return Object.assign({}, state, {
				activationStep: action.step,
				resendCode: action.resendCode
			});
			break;

		case types.MSISDN_IN_HEADER:
			return Object.assign({}, state, {
				msisdn: action.msisdn,
				msisdnInHeader: (action.msisdn) ? action.msisdn : false
			});
			break;
	}

	return state;
};

export default loginReducer;


// WEBPACK FOOTER //
// ./src/reducers/login-reducer.js